import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "plex-regular flex flex-col items-center justify-center bg-center md:bg-left-top bg-no-repeat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "flex flex-col items-center w-full" }, [
      _createElementVNode("img", {
        class: "object-contain w-11/12 md:w-7/12 lg:w-5/12 xl:w-4/12 md:py-0",
        src: _imports_0
      })
    ], -1)
  ]))]))
}